import { render } from "./ChartTabsItem.vue?vue&type=template&id=d8f3985e"
import script from "./ChartTabsItem.vue?vue&type=script&lang=js"
export * from "./ChartTabsItem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__